import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

import { getEnv } from '@/config/env'

import { sharedCookieDomain } from './cookie-domain'

let configured = false

export const AUTH_COOKIE_EXPIRY_DAYS = 30

export function authCookieStorage(domain: string): CookieStorage {
  return new CookieStorage({
    domain,
    path: '/',
    secure: true,
    sameSite: 'lax',
    expires: AUTH_COOKIE_EXPIRY_DAYS,
  })
}

export function configureAmplify(): void {
  if (configured) return

  const env = getEnv()

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: env.VITE_COGNITO_CLIENT_ID,
      },
    },
  })

  const cookieDomain = sharedCookieDomain()

  if (cookieDomain !== '') {
    cognitoUserPoolsTokenProvider.setKeyValueStorage(authCookieStorage(cookieDomain))
  }

  configured = true
}

export function resetAmplifyConfigurationForTests(): void {
  configured = false
}
